<template>
    <div class="page myPaperPage">
        <!--<h3 class="page-title">{{$t('paper.paperLibrary')}}</h3>-->

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('paper.name')">
                <el-input v-model="formSearch.title" :placeholder="$t('tip.paperName')"
                          :class="{'big-input': $i18n.locale==='en'}"
                          @keyup.enter.native="queryPapers"
                          clearable></el-input>
            </el-form-item>

            <select-multiple :nameArrays="selectNames"
                             @getForLevelVal="getForLevelVal"
                             @getPaperTypeVal="getPaperTypeVal"
                             @getDifficultyVal="getDifficultyVal"
                             @getPaperMethodVal="getPaperMethodVal"
            >
            </select-multiple>

            <select-multi-knowledge @knowledgeChange="knowledgeChange"></select-multi-knowledge>
            <el-form-item :label="$t('c.creator')">
                <el-input v-model="formSearch.creatorName" :placeholder="$t('tip.creator')" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('c.productionDate')">
                <el-date-picker
                    v-model="formSearch.afterDate"
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>{{$t('c.to')}}</span>
                <el-date-picker
                    v-model="formSearch.beforeDate"
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryPapers" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">
            <data-tables class="form-table"
                     ref="courseTable"
                     :data="tableData"
                     :table-props="tableProps"
                     :current-page.sync="currentPage"
                     :page-size="20"
                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
        >
            <el-table-column property="title" :label="$t('paper.name')" align="center"
                             min-width="190px" show-overflow-tooltip></el-table-column>
            <el-table-column property="typeName" :label="$t('paper.type')" align="center" width="105px" show-overflow-tooltip sortable>
                <template #default="{row}">
                    <type-tag type="paperType" :id="row.type" :name="row.typeName"></type-tag>
                </template>
            </el-table-column>
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                             align="center"
                             :width="title.width" :min-width="title.minWidth"
                             show-overflow-tooltip
                             :sortable="title.sortable">
            </el-table-column>
            <!-- column buttons -->
            <el-table-column :label="$t('c.operation')" align="center">
                <div class="btn-cell" slot-scope="scope">
                    <i
                        :title="$t('c.view')"
                        class="nucfont inuc-preview"
                        @click="previewPaper(scope.row)">
                    </i>

                </div>
            </el-table-column>
        </data-tables>
        </div>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @needUpdate="queryPapers"></router-view>
        </transition>

        <!-- 图像全屏查看 -->
        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </div>
</template>

<script>
    import api from '@/api';
    import {screenfull} from '@/utils';
    import FullScreen from '@/components/FullScreen.vue';
    import selectMultiKnowledge from '@/components/SelectMultiKnowledge';
    import selectMultiple from '@/components/Selectmultiple'

    export default {
        data(){
            return{
                isShow: false,
                src: null,
                formSearch:{
                    title:'',
                    types: [],
                    forLevels: [],
                    difficulties: [],
                    methods: [],
                    afterDate: '',
                    beforeDate: '',
                    knowledges:[0],
                    creatorName:''
                },
                selectNames: [
                    {
                        key: "paperType",
                    }, {
                        key: "forLevel",
                    },{
                        key: "difficulty",
                    }, {
                        key: "paperMethod",
                    }],
                isDeleteShow: false,
                tableData:[],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'methodName',
                        label: this.$t('paper.paperMethod')
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    }, {
                        prop: 'forLevelName',
                        label: this.$t('c.operatorLevel')
                    }, {
                        prop: 'totalScore',
                        label: this.$t('paper.paperScore'),
                        sortable: 'custom'
                    }, {
                        prop: 'passScore',
                        label: this.$t('paper.passScore'),
                        sortable: 'custom'
                    }, {
                        prop: 'knowledgeName',
                        label: this.$t('c.knowledgePoint')
                    }, {
                        prop: 'difficultyName',
                        label: this.$t('c.difficulty'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'creatorName',
                        label: this.$t('c.creator'),
                        sortable: 'custom'
                    },
                ],
            }
        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.beforeDate) return false;
                        return time.getTime() > new Date(that.formSearch.beforeDate).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.afterDate) return false;
                        return time.getTime() < new Date(that.formSearch.afterDate).getTime()
                    },
                }
            },
        },
        created() {
            this.queryPapers()
        },
        methods:{
            queryPapers(){
                this.currentPage = 1;
                let queryData = {...this.formSearch};

                // 全选不传值
                ['types', 'forLevels', 'difficulties', 'methods', 'knowledges'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                api.getPaperList(queryData).then(res => {
                    for (let i = 0; i < res.package.length; i++) {
                        res.package[i].createTime ? res.package[i].createTime = res.package[i].createTime.replace("T", " ") : res.package[i].createTime = "—";
                    }
                    this.tableData = res.package;
                })
            },

            previewPaper({id, type}) {
                console.log(id, type)
                switch (type) {
                    case 1:
                        this.$router.push({name: 'paperPreview',params: {paperId: id}});
                        screenfull.request();
                        break;
                    case 3:
                        this.isShow = !this.isShow
                        this.src = `${api.imagePanoramicHost}/ctPaperDetail?paperId=${id}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/CT_base.html?type=PAPER_PREVIEW&paperID=${id}`
                        this.$refs.nstswrap.fullScreen()
                        break
                    case 4:
                        this.isShow = !this.isShow
                        this.src = `${api.imagePanoramicHost}/drPaperDetail?paperId=${id}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/DR_base.html?type=PAPER_PREVIEW&paperID=${id}`
                        this.$refs.nstswrap.fullScreen()
                        break
                    case 5:
                        // todo: 查看职鉴考卷
                        this.$router.push({name: 'paperPreview',params: {paperId: id}, query: {isFiscan: true}});
                        screenfull.request();
                        break
                    default:
                        break
                }
            },
            // 图像考卷预览
            toggleIsShow (val) {
                this.isShow = val;
                this.src = null
            },

            //搜索赋值
            getPaperTypeVal(data){
                this.formSearch.types = data;
            },
            getForLevelVal(data){
                this.formSearch.forLevels = data;
            },
            getDifficultyVal(data) {
                this.formSearch.difficulties = data;
            },
            knowledgeChange(data) {
                this.formSearch.knowledges = data;
            },
            getPaperMethodVal(data) {
                this.formSearch.methods = data;
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        components: {
            selectMultiple,
            selectMultiKnowledge,
            FullScreen
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .big-input {
        width: 205px;
    }
</style>


